export default {"src":"/assets/turbo/0980fac0/ackermannch/_next/static/media/favicon.c00d51d7.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};